/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamSchema } from './teamSchema';

export const pageResponseTeamSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(teamSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
